import request from '../request';
import md5 from 'js-md5';

export const reactivateApi = {
  reactivateAcc(data) {
    let _data = {
      data: data.key,
      pwd: md5(data.pwd),
      gaCode: data.gaCode
    };
    return request({
      url: '/user/reactivate',
      method: 'post',
      data: _data
    });
  },
  checkReactivateAcc(data) {
    return request({
      url: '/user/check/reactivate',
      method: 'post',
      data
    });
  }
};
